// General
import "./geolocation-permission-prompt-dialog.scss";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// Services
import { useUpdateUserLocationMutation } from "../../../../services/data.service";
import { sessionService } from "../../../../services/session.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateGeolocationPermissionPromptDialog } from "../../../../redux/store/dialogStore";
// Material UI
import { Dialog, ButtonBase } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";
// moment
import moment from "moment";
// Custom Hooks
import IconManager from "../../../utility/manager/icon-manager/icon-manager";

const GeolocationPermissionPromptDialog = () => {
  // API variables
  const [
    updateUserLocation,
    {
      data: updateUserLocationData,
      error: updateUserLocationErrorData,
      isLoading: updateUserLocationLoading,
      isSuccess: updateUserLocationSuccess,
      isError: updateUserLocationError,
    },
  ] = useUpdateUserLocationMutation();

  // General variables
  const [backdropCounter, setBackdropCounter] = useState(0);

  // Redux variables
  const geolocationPermissionPromptDialog = useSelector(
    (state) => state.dialog.geolocationPermissionPromptDialog
  );
  const isLoggedIn = useSelector((state) => state.public.isLoggedIn);
  const dispatch = useDispatch();

  // Router variables
  const location = useLocation();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getIcon = IconManager();

  // Lifecycle | Mounted
  useEffect(() => {
    if (geolocationPermissionPromptDialog) {
    } else {
    }
  }, [geolocationPermissionPromptDialog]);

  // Lifecycle | Check for update | backdropCounter | Easter Egg to close dialog
  useEffect(() => {
    if (backdropCounter < 10) return;

    dispatch(updateGeolocationPermissionPromptDialog(false));
  }, [backdropCounter]);

  // Event Handlers | Button
  const onPromptPermission = () => {
    getGpsLocation();
    onCloseDialog();
  };
  const onLearnMore = () => {
    onCloseDialog();
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = (event, reason) => {
    setBackdropCounter((prevBackdropCounter) => prevBackdropCounter + 1);

    if (reason === "backdropClick") return;

    dispatch(updateGeolocationPermissionPromptDialog(false));
  };

  // Utility Functions
  const getGpsLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Save to local storage
          const locationDataObj = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            lastRequested: moment().toDate(),
          };
          sessionService.setLocationData(locationDataObj);

          // Call Update Location API | Only if isLoggedIn = true
          if (isLoggedIn) {
            const locationObj = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              type: "device_gps",
            };
            updateUserLocation(locationObj);
          }

          dispatch(updateGeolocationPermissionPromptDialog(false));
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              break;
            case error.POSITION_UNAVAILABLE:
              break;
            case error.TIMEOUT:
              break;
            case error.UNKNOWN_ERROR:
              break;
            default:
              break;
          }
        }
      );
    } else {
    }
  };

  // Unmounted when closed, otherwise a dropped MUI transition can leave the backdrop visible with the dialog stuck invisible
  return (
    geolocationPermissionPromptDialog && (
      <Dialog
        className="custom-radius35-dialog"
        open={geolocationPermissionPromptDialog}
        onClose={onCloseDialog}
      >
        <div id="geolocation-permission-prompt-dialog">
          <div className="padding-container">
            <div className="location-permission-icon-container">
              {getIcon("locationPermissionIcon", "location-permission-icon")}
            </div>

            <div className="geolocation-prompt-title">
              {t("location.location_permission_prompt_title")}
            </div>
            <div className="geolocation-prompt-desc">
              {t("location.location_permission_prompt_desc")}
            </div>

            <div className="buttons-container">
              <ButtonBase
                className="allow-button"
                component="div"
                onClick={onPromptPermission}
              >
                {t("common.allow")}
              </ButtonBase>

              {false && (
                <div className="learn-more-button" onClick={onLearnMore}>
                  {t("common.learn_more")}
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    )
  );
};

export default GeolocationPermissionPromptDialog;
